/* LOOKBOOK（メタオブジェクト連動）の挙動
   - 並べ替え
   - 「もっと見る」による段階表示
   - タイルをクリックしてモーダルを開く
   sections/lookbook.liquid と sections/related-lookbook.liquid が共有する。 */
(function () {
  'use strict';

  /* 並べ替えを Liquid ではなく JS で行っている理由:
     Liquid で metaobject を並べ替えるには values をなめてキーを作り、
     shop.metaobjects.<type>[handle] で引き直す必要があるが、
     この引き直しは1リクエスト約20回で頭打ちになり、以降が直前の値のまま複製される。
     values は整数添字での参照もできない。
     そのため Liquid は values の自然順のまま出力し、各タイルが持つ
     data-sort-key（= system.id）と data-sort-handle を使って JS 側で並べ替える。 */
  function sortItems(container, grid) {
    var order = container.dataset.sortOrder || 'created_desc';
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-lookbook-item]'));

    if (order === 'random') {
      // Fisher-Yates。ページはキャッシュされるため、訪問ごとに変えるにはクライアント側で振る。
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i];
        items[i] = items[j];
        items[j] = tmp;
      }
    } else if (order === 'handle_asc' || order === 'handle_desc') {
      items.sort(function (a, b) {
        return (a.dataset.sortHandle || '').localeCompare(b.dataset.sortHandle || '');
      });
      if (order === 'handle_desc') items.reverse();
    } else {
      // created_asc / created_desc: メタオブジェクトIDは単調増加するため登録順の代用になる
      items.sort(function (a, b) {
        return Number(a.dataset.sortKey || 0) - Number(b.dataset.sortKey || 0);
      });
      if (order !== 'created_asc') items.reverse();
    }

    var fragment = document.createDocumentFragment();
    items.forEach(function (item) {
      fragment.appendChild(item);
    });
    grid.appendChild(fragment);

    return items;
  }

  function setupLoadMore(container, items) {
    var moreWrap = container.querySelector('[data-lookbook-more]');
    var button = container.querySelector('[data-lookbook-more-button]');
    var visibleEl = container.querySelector('[data-lookbook-visible]');
    var initialLimit = parseInt(container.dataset.initialLimit, 10);
    var perLoad = parseInt(container.dataset.itemsPerLoad, 10);

    if (!initialLimit || initialLimit < 1) initialLimit = items.length;
    if (!perLoad || perLoad < 1) perLoad = items.length;

    var visible = 0;

    function render() {
      visible = Math.min(visible, items.length);
      items.forEach(function (item, index) {
        item.hidden = index >= visible;
      });
      if (visibleEl) visibleEl.textContent = String(visible);
      if (moreWrap) moreWrap.hidden = visible >= items.length;
    }

    visible = Math.min(initialLimit, items.length);
    render();

    if (button) {
      button.addEventListener('click', function () {
        visible = Math.min(visible + perLoad, items.length);
        render();
      });
    }
  }

  function setupModal(container) {
    var modal = container.querySelector('[data-lookbook-modal]');
    if (!modal) return;

    var image = modal.querySelector('[data-lookbook-modal-image]');
    var list = modal.querySelector('[data-lookbook-modal-list]');
    var empty = modal.querySelector('[data-lookbook-modal-empty]');
    var lastTrigger = null;

    function open(item) {
      lastTrigger = item;

      if (image) {
        image.classList.remove('is-loaded');
        image.alt = item.dataset.modalAlt || '';
        image.addEventListener('load', function onLoad() {
          image.classList.add('is-loaded');
          image.removeEventListener('load', onLoad);
        });
        image.src = item.dataset.modalImage || '';
        // キャッシュ済みで load が発火しない場合の保険
        if (image.complete && image.naturalWidth !== 0) image.classList.add('is-loaded');
      }

      if (list) {
        list.innerHTML = '';
        // 商品カードは Liquid が <template> にレンダリング済み。
        // JSON を組み立てないので、価格の書式もエスケープも Liquid のままで済む。
        var template = item.querySelector('template[data-lookbook-products]');
        var hasProducts = template && template.content.children.length > 0;
        if (hasProducts) {
          list.appendChild(template.content.cloneNode(true));
        }
        if (empty) empty.hidden = !!hasProducts;
      }

      modal.classList.add('is-active');
      document.body.classList.add('lookbook-modal-open');

      var close = modal.querySelector('[data-lookbook-modal-close]');
      if (close) close.focus();
    }

    function close() {
      modal.classList.remove('is-active');
      document.body.classList.remove('lookbook-modal-open');
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    container.querySelectorAll('[data-lookbook-item].lookbook__item--clickable').forEach(function (item) {
      item.addEventListener('click', function () {
        open(item);
      });
      item.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(item);
        }
      });
    });

    modal.querySelectorAll('[data-lookbook-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-active')) close();
    });
  }

  function init(container) {
    if (!container || container.dataset.lookbookReady === 'true') return;
    container.dataset.lookbookReady = 'true';

    var grid = container.querySelector('[data-lookbook-grid]');
    if (!grid) return;

    var items = sortItems(container, grid);
    setupLoadMore(container, items);
    setupModal(container);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-lookbook]').forEach(function (container) {
      init(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // テーマエディタでセクションを編集すると DOM が差し替わるので張り直す
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
